<template>
<v-dialog
    v-model="dialog"
    max-width="1250"
>
<v-card>
    <v-card-title>Templates</v-card-title>

    <v-card-text>
        <v-stepper 
            v-model="step"
        >
            <v-stepper-header>
                <v-stepper-step
                    :complete="step > 1"
                    step="1"

                    v-on:click="step = 1"
                    class="step-header"
                >
                    Types
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step
                    :complete="step > 2"
                    step="2"
                    v-on:click="onClickStep2"
                    class="step-header"
                >
                    Templates
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="3">
                    Preview
                </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
                <v-stepper-content 
                    step="1"
                >
                    <v-container
                        fluid
                        style="padding-left: 30px; padding-right: 30px;"
                        grid-list-xl
                    >
                        <m-bulk-message-template-type-cards
                            v-on:create-message="onClickCreateMessage"
                            v-on:view-all="onClickViewAll"
                        />
                    </v-container>
                    
                </v-stepper-content>
                    
                <v-stepper-content step="2">
                    <m-bulk-message-template-view-all-cards
                        v-if="selected_type != null"
                        :template_type="selected_type"
                        v-on:create-message="onClickCreateMessage"
                        action_label="Select"
                    />
                </v-stepper-content>

                <v-stepper-content step="3">
                    <div
                        v-if="selected_template != null"
                        v-html="$rc.wrapHTML(selected_template.message_patterns[0])"
                    /> 
                </v-stepper-content>

            </v-stepper-items>
        </v-stepper>
    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            text
            @click="onCancel"
        >
            Cancel
        </v-btn>

        <v-btn
            text
            @click="onOk"
            :disabled="step != 3"
            color="primary"
        >
            Use This Template
        </v-btn>

    </v-card-actions>

</v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            selected_template: null,
            selected_type: null,
            step: 1,
        }
    },

    methods: {

        showDialog()
        {
            this.selected_template = null;
            this.selected_type = null;

            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
            this.$emit('ok', this.selected_template);
        },

        onCancel()
        {
            this.dialog = false;
        },

        onClickCreateMessage(template)
        {
            this.selected_template = template;
            this.step = 3;
        },

        onClickViewAll(type)
        {
            this.selected_type = type;
            this.step = 2;
        },

        onClickStep1()
        {
            this.selected_template = null;
            this.selected_type = null;
            this.step = 1;
        },

        onClickStep2()
        {
            if ( this.selected_type == null ) 
            {
                this.onClickStep1();
            }
            else 
            {
                this.step = 2;
            }
        },

    },
}
</script>

<style lang="scss" scoped>
.step-header:hover
{
    cursor: pointer;
}
</style>